module.exports = __webpack_public_path__ + "img/ConditionMonitor_mehrfarbig_RGB.9dfee2c8.svg";